import { Collapse, Form } from 'antd';
import translations from '../../hooks/translation/translations.json';
import SelectInput from '../inputs/SelectInput';
import TextInput from '../inputs/TextInput';
import useTranslation from '../../hooks/translation/useTranslation';

function PaymentDetailsForm({ form }) {
  const { trans } = useTranslation();
  return (
    <Form
      layout="vertical"
      disabled
      form={form}
    >
      <Collapse style={{ maxWidth: '640px', marginBottom: '3rem' }} defaultActiveKey={1}>
        <Collapse.Panel key={1} header={trans('payment_data')}>
          <TextInput label={`${trans('paid_amount')}*`} name="amount" />
          <SelectInput name="status" label={`${translations.ka.status}*`} />
          <TextInput
            label={`${trans('payment_link')}*`}
            name="payment_url"
          />
          <TextInput
            label={`${trans('returned_amount')}*`}
            name="refunded_amount"
          />
          <TextInput
            label={`${trans('payment_system_id')}*`}
            name="id"
          />
          <TextInput
            label={`${trans('payment_bank_id')}*`}
            name="payment_id"
          />
        </Collapse.Panel>
        <Collapse.Panel key="2" header={trans('personal_data')}>
          <TextInput label={`${trans('username')}*`} name="name" />
          <TextInput label={`${trans('email')}*`} name="email" />
          <TextInput
            label={`${trans('phone_number')}*`}
            name="phone_number"
          />
        </Collapse.Panel>
      </Collapse>
    </Form>
  );
}

export default PaymentDetailsForm;
